/*
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-15 16:45:12
 * @LastEditTime: 2026-04-16 20:23:02
 * @LastEditors: ranli
 */
// 定义比赛状态枚举
// 状态1-Scheduled(即将开始), 2-Completed(完成), 3-Live(进行中) 已取消 4-Aborted(已取消)
export const MatchStatus = {
  NOT_STARTED: 1,
  COMPLETED: 2,
  LIVE: 3,
  ABORTED: 4,
}
/**
 * 比赛状态映射
 */
export const MatchStatusMap = {
  [MatchStatus.NOT_STARTED]: 'Scheduled',
  [MatchStatus.COMPLETED]: 'Completed',
  [MatchStatus.LIVE]: 'Live',
  [MatchStatus.ABORTED]: 'Aborted',
}
// //
// 运营状态
// 1 未开始报名—— 比赛不开放
// 2 报名开始—— 可以创建队伍进行报名，可以随时修改队伍
// 3 报名截止—— 不能报名，且队伍锁定队伍，不能修改
// 4 Live —— 比赛进行中，整体房间内部状态会变调
// 5 结算中 —— 比赛已经结束，正在进行结算
// 6 已结束 —— 结算完成后的赛事，结束掉
// 7 已取消 ——因为一些异常原因取消掉了，需要给已经报名的用户退款
export const OperationStatus = {
  NOT_STARTED_OPERATION: 1,
  STARTED_OPERATION: 2,
  ENDED_OPERATION: 3,
  LIVE_OPERATION: 4,
  SETTLED_OPERATION: 5,
  COMPLETED_OPERATION: 6,
  CANCELLED_OPERATION: 7,
}
/**
 * 运营状态映射
 */
export const OperationStatusMap = {
  [OperationStatus.NOT_STARTED_OPERATION]: 'Not Started Operation',
  [OperationStatus.STARTED_OPERATION]: 'Started Operation',
  [OperationStatus.ENDED_OPERATION]: 'Ended Operation',
  [OperationStatus.LIVE_OPERATION]: 'Live Operation',
  [OperationStatus.SETTLED_OPERATION]: 'Settled Operation',
  [OperationStatus.COMPLETED_OPERATION]: 'Completed Operation',
  [OperationStatus.CANCELLED_OPERATION]: 'Cancelled Operation',
}
